<template>
  <div class="system">
<!--     顶部横幅 - 仅保留图片
    <div class="top">
      <img :src="top" style="width: 100%;height: 450px" alt="系统解决方案">
    </div>-->

    <div class="background">
      <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
      <div class="background-text">
        <p>系统方案</p>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="con_data">
      <div class="section-header">
        <h2 class="blue">系统解决方案</h2>
        <p class="section-subtitle">我们提供全面的系统解决方案，满足您的各种需求</p>
        <div class="section-divider"></div>
      </div>
      
      <div class="solution-grid">
        <div class="solution-card" v-for="(item, index) in imgData" :key="index" 
             :style="{'animation-delay': index * 0.1 + 's'}">
          <div class="solution-image">
            <router-link :to="{path:'/sysDetails',query:{Id:item.Id}}">
              <img :src="item.NewsImg" alt="系统解决方案">
              <div class="solution-overlay">
                <span>查看详情</span>
              </div>
            </router-link>
          </div>
          <div class="solution-info">
            <h3>{{item.NewsTitle}}</h3>
            <p v-if="item.NewsBrief">{{item.NewsBrief}}</p>
            <router-link :to="{path:'/sysDetails',query:{Id:item.Id}}" class="solution-link">
              了解更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "system",
  data(){
    return{
      top:'',
      imgData:[],
      img_1:require('../../assets/05.png'),
    }
  },
  mounted() {
    this.getTop();
    this.getImg();
    // 添加滚动动画
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    //获取banner
    getTop(){
      let data={params:{ImgCate:7}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取图片
    getImg(){
      let data={params:{NewsCate:1}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.imgData = res.data;
      })
    },
    // 滚动动画
    handleScroll() {
      const cards = document.querySelectorAll('.solution-card');
      cards.forEach(card => {
        const cardTop = card.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (cardTop < windowHeight * 0.8) {
          card.classList.add('visible');
        }
      });
    }
  }
}
</script>

<style scoped>
/* 顶部横幅 - 简化为只有图片 */
.top {
  width: 100%;
  overflow: hidden;
}

/* 内容区域样式保持不变 */
.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 32px;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.section-divider {
  width: 60px;
  height: 3px;
  background: #1890ff;
  margin: 0 auto;
}

/* 解决方案卡片网格 */
.solution-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.solution-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s ease forwards, slideUp 0.8s ease forwards;
}

.solution-card.visible {
  opacity: 1;
  transform: translateY(0);
}

.solution-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

.solution-image {
  position: relative;
  height: 220px;
  overflow: hidden;
}

.solution-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.solution-card:hover .solution-image img {
  transform: scale(1.1);
}

.solution-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.solution-overlay span {
  color: white;
  font-size: 16px;
  padding: 8px 20px;
  border: 2px solid white;
  border-radius: 30px;
}

.solution-card:hover .solution-overlay {
  opacity: 1;
}

.solution-info {
  padding: 20px;
}

.solution-info h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
  transition: color 0.3s ease;
}

.solution-info p {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 1.6;
}

.solution-link {
  display: inline-block;
  color: #1890ff;
  font-size: 14px;
  transition: all 0.3s ease;
}

.solution-link:hover {
  color: #40a9ff;
  transform: translateX(5px);
}

.solution-link i {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.solution-link:hover i {
  transform: translateX(3px);
}

@media (max-width: 768px) {
  .solution-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
}

/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
</style>